import {
  Component,
  ViewEncapsulation,
  OnInit,
  OnDestroy
} from '@angular/core';
import {
  State
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  GridDataResult, SelectionEvent,
} from '@progress/kendo-angular-grid';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import {
  Observable
, Subscription} from 'rxjs';
import {
  FormControl
} from '@angular/forms';
import * as moment from 'moment';
import {Router} from '@angular/router';
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {OrdersService} from '../orders/orders.service';



@Component({
  selector: 'app-distributor-orders',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'distributor-orders.template.html',
  animations: [
    trigger('slideIn', [
      state('*', style({ 'overflow-y': 'hidden' })),
      state('void', style({ 'overflow-y': 'hidden' })),
      transition('* => void', [
        style({ height: '*' }),
        animate(250, style({ height: 0 }))
      ]),
      transition('void => *', [
        style({ height: '0' }),
        animate(250, style({ height: '*' }))
      ])
    ])
  ]
})
export class DistributorOrdersComponent implements OnInit, OnDestroy {
  public view: Observable<GridDataResult>;
  public subscription: Subscription;
  public state: State = {
    skip: 0,
    take: 10
  };

  public searchText = new FormControl();

  start: Date = moment().subtract(30, 'days').toDate();
  end: Date = moment().toDate();
  orderTypes: string[] = ['orthotics', 'gait'];
  filter = false;
  loading = false;

  constructor(private router: Router, private service: OrdersService) {

    this.view = service;
    this.subscription = service.subscription;
    this.getOrders('');
  }

  public ngOnInit(): void {
    this.searchText.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((term) => {
        if (term.length >= 3 || term.length === 0) {
          this.state.skip = 0;
          this.getOrders(term);
        }
      });
    console.log('finished initing order component');

  }

  public ngOnDestroy(): void {
  }

  public selectedRow(event: SelectionEvent) {
      this.router.navigate(['', 'orders', `${event.selectedRows[0].dataItem._id}`]);
  }

  public filterFieldChanged(): void {
    this.getOrders(this.searchText.value || '');
    console.log('filterFieldChanged');
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.getOrders('');
  }

  public getOrders(search) {
    this.loading = true;
    const page = this.state.skip / this.state.take + 1;
    const limit = this.state.take;
    const start = this.filter ? moment(this.start).toISOString() : '';
    const end = this.filter ? moment(this.end).toISOString() : '';

    this.service.getList(start, end, page, limit, () => {
      this.loading = false;
    }, search);
  }

}
